module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/155-israel-3c64e4c60806a94fda0be1833096925d.svg";